module.exports = __webpack_public_path__ + "static/pigly02-sq-28980b1c6554401b5e9124b94564b44c.png";